import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { apiInstance } from '../services/service-trips-api/service-trips-api';
import type { ScheduleTypeDto } from '../services/service-trips-api/types';
import { QueryKeys } from './types';

export const useScheduleTypesQuery = (): UseQueryResult<ScheduleTypeDto[]> => {
  return useQuery({
    queryKey: [QueryKeys.ScheduleTypes],
    queryFn: async () => {
      const response = await apiInstance.getScheduleTypes();
      return response._embedded?.scheduleTypes ?? [];
    },
    staleTime: 10 * 60 * 1000, // 10 minutes — schedule types rarely change
  });
};
